/**
 * Schémas pour l'espace responsable de formation (Phase 4).
 */
import { z } from 'zod';
import { emailSchema } from './common.js';
export const responsableUpdateStudentSchema = z.object({
    // V1.0 (mai 2026) : statuts étendus (paused / placed / archived) + alias
    // legacy fulfilled pendant la phase expand/contract. Cf. CdC V3 §5.1.
    status: z
        .enum(['draft', 'published', 'paused', 'placed', 'archived', 'fulfilled'])
        .optional(),
    // Désactivation = on remet le compte en draft + on lock le user (côté API)
    desactiver: z.boolean().optional(),
    noteResponsable: z.string().max(500).optional().or(z.literal('')),
});
/**
 * Rejette les valeurs qui commencent par un caractère de formule Excel/Calc
 * (=, +, -, @). Ces caractères déclenchent l'exécution de formules si les
 * données CSV sont réexportées et ouvertes dans un tableur (CSV injection).
 */
const noCsvInjection = (val) => !/^[=+\-@]/.test(val);
const CSV_INJECTION_MESSAGE = 'Valeur invalide (caractère de formule interdit en début de champ).';
export const csvInvitationRowSchema = z.object({
    email: emailSchema.refine(noCsvInjection, { message: CSV_INJECTION_MESSAGE }),
    prenom: z
        .string()
        .trim()
        .min(1)
        .max(100)
        .refine(noCsvInjection, { message: CSV_INJECTION_MESSAGE })
        .optional(),
    nom: z
        .string()
        .trim()
        .min(1)
        .max(100)
        .refine(noCsvInjection, { message: CSV_INJECTION_MESSAGE })
        .optional(),
    formationCode: z.string().trim().min(1),
    academicYear: z
        .string()
        .trim()
        .regex(/^\d{4}-\d{4}$/)
        .optional(),
});
export const archivePromotionSchema = z.object({
    status: z.enum(['active', 'archived']),
});
//# sourceMappingURL=responsable.js.map